import React from 'react';
import ReactDOM from 'react-dom';
import './reset.css';
import './index.css';
import './animista.css';
import App from './Pages/App/App';
import reportWebVitals from './reportWebVitals';

declare module '*.png';
declare module '*.jpg';
declare module '*.svg';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
